import React from "react";
import { animated, useTransition } from "react-spring";
import styled from "../../styled";
import { Notification } from "../notification";
import { useToast } from "../use-toast/use-toast";
import { useToastTimer } from "./use-toast-timer/use-toast-timer";
/** The animations for entering. */
const enter = {
    top: "translate3d(0, -100%, 0)",
    bottom: "translate3d(0, 100%, 0)",
};
/** The animations for exiting. */
const exit = {
    top: "translate3d(0, 100%, 0)",
    bottom: "translate3d(0, -100%, 0)",
};
export const Toast = ({ id, timeout, action, message, position, mode = "neutral", direction, onClose, dataAnchor = "animated-toast", }) => {
    const [vertical, _] = position.split("-");
    const { show, close, startTimer, pauseTimer } = useToastTimer(timeout);
    const { removeToast } = useToast();
    const onDestroyed = (remove) => {
        if (remove) {
            removeToast(id);
        }
        onClose === null || onClose === void 0 ? void 0 : onClose(id);
    };
    const transitions = useTransition(show, null, {
        config: {
            duration: 250,
        },
        from: { opacity: 1, transform: enter[vertical] },
        enter: { opacity: 1, transform: "translate3d(0%, 0%, 0)" },
        leave: { opacity: 0, transform: exit[vertical] },
        onDestroyed,
    });
    return (React.createElement(React.Fragment, null, transitions.map(({ item, key, props: style }) => item && (React.createElement(AnimatedToast, { "data-anchor": dataAnchor, style: style, key: key, onMouseEnter: pauseTimer, onMouseLeave: startTimer },
        React.createElement(Notification, { status: mode, onClose: close, action: action, direction: direction, dataAnchor: "alert-inner" }, message))))));
};
export default Toast;
const AnimatedToast = styled((props) => React.createElement(animated.div, Object.assign({}, props))) `
  pointer-events: all;
  width: 100%;
  border-radius: ${(p) => p.theme._ui.radii.small};
  box-shadow: ${(props) => props.theme._ui.shadows.large};
`;
